const { CALL_INTAKE_V2_API } = require('middleware/intakeV2Api');
const {
  GET_AUTH_OFFER_HISTORY_LIST_REQUEST,
  GET_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  GET_AUTH_OFFER_HISTORY_LIST_FAILURE,
  POST_AUTH_OFFER_HISTORY_LIST_REQUEST,
  POST_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  POST_AUTH_OFFER_HISTORY_LIST_FAILURE,
  UPDATE_AUTH_OFFER_HISTORY_LIST_REQUEST,
  UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  UPDATE_AUTH_OFFER_HISTORY_LIST_FAILURE,
  DELETE_AUTH_OFFER_HISTORY_LIST_REQUEST,
  DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  DELETE_AUTH_OFFER_HISTORY_LIST_FAILURE,
  GET_AUTH_HOUSE_HUNTING_LIST_REQUEST,
  GET_AUTH_HOUSE_HUNTING_LIST_SUCCESS,
  GET_AUTH_HOUSE_HUNTING_LIST_FAILURE,
  POST_AUTH_HOUSE_HUNTING_LIST_REQUEST,
  POST_AUTH_HOUSE_HUNTING_LIST_SUCCESS,
  POST_AUTH_HOUSE_HUNTING_LIST_FAILURE,
  UPDATE_AUTH_HOUSE_HUNTING_LIST_REQUEST,
  UPDATE_AUTH_HOUSE_HUNTING_LIST_SUCCESS,
  UPDATE_AUTH_HOUSE_HUNTING_LIST_FAILURE,
  DELETE_AUTH_HOUSE_HUNTING_LIST_REQUEST,
  DELETE_AUTH_HOUSE_HUNTING_LIST_SUCCESS,
  DELETE_AUTH_HOUSE_HUNTING_LIST_FAILURE,
  GET_AUTH_DESTINATION_SERVICES_REQUEST,
  GET_AUTH_DESTINATION_SERVICES_SUCCESS,
  GET_AUTH_DESTINATION_SERVICES_FAILURE,
  UPDATE_AUTH_DESTINATION_SERVICES_BUYER_REQUEST,
  UPDATE_AUTH_DESTINATION_SERVICES_BUYER_SUCCESS,
  UPDATE_AUTH_DESTINATION_SERVICES_BUYER_FAILURE,
  UPDATE_AUTH_DESTINATION_SERVICES_RENTER_REQUEST,
  UPDATE_AUTH_DESTINATION_SERVICES_RENTER_SUCCESS,
  UPDATE_AUTH_DESTINATION_SERVICES_RENTER_FAILURE,
  UPDATE_AUTH_HOUSE_HUNTING_BUYER_FAILURE,
  UPDATE_AUTH_HOUSE_HUNTING_BUYER_SUCCESS,
  UPDATE_AUTH_HOUSE_HUNTING_BUYER_REQUEST,
  UPDATE_AUTH_HOUSE_HUNTING_RENTER_REQUEST,
  UPDATE_AUTH_HOUSE_HUNTING_RENTER_SUCCESS,
  UPDATE_AUTH_HOUSE_HUNTING_RENTER_FAILURE,
  DELETE_AUTH_HOUSE_HUNTING_RENTER_REQUEST,
  DELETE_AUTH_HOUSE_HUNTING_RENTER_SUCCESS,
  DELETE_AUTH_HOUSE_HUNTING_RENTER_FAILURE,
  DELETE_AUTH_HOUSE_HUNTING_BUYER_FAILURE,
  DELETE_AUTH_HOUSE_HUNTING_BUYER_SUCCESS,
  DELETE_AUTH_HOUSE_HUNTING_BUYER_REQUEST,
  UPDATE_MORTGAGE_LEADS_REQUEST,
  UPDATE_MORTGAGE_LEADS_SUCCESS,
  UPDATE_MORTGAGE_LEADS_FAILURE,
  GET_MORTGAGE_LEADS_REQUEST,
  GET_MORTGAGE_LEADS_SUCCESS,
  GET_MORTGAGE_LEADS_FAILURE,
  SEND_MORTGAGE_LEADS_REQUEST,
  SEND_MORTGAGE_LEADS_SUCCESS,
  SEND_MORTGAGE_LEADS_FAILURE,
  GET_AUTH_DESTINATION_ESTIMATED_DATES_REQUEST,
  GET_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS,
  GET_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE,
  UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_REQUEST,
  UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS,
  UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE
} = require('../types/destinationServiceTypes');

export const getOfferHistoryList = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_OFFER_HISTORY_LIST_REQUEST, GET_AUTH_OFFER_HISTORY_LIST_SUCCESS, GET_AUTH_OFFER_HISTORY_LIST_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/destinationService/buyer/offerHistory`,
      method: 'GET'
    }
  };
};

export const postOfferHistoryList = (id, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_OFFER_HISTORY_LIST_REQUEST, POST_AUTH_OFFER_HISTORY_LIST_SUCCESS, POST_AUTH_OFFER_HISTORY_LIST_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/destinationService/buyer/offerHistory`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateOfferHistoryList = (id, offerId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_OFFER_HISTORY_LIST_REQUEST, UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS, UPDATE_AUTH_OFFER_HISTORY_LIST_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/destinationService/buyer/offerHistory/${offerId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteOfferHistoryList = (id, offerId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_OFFER_HISTORY_LIST_REQUEST, DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS, DELETE_AUTH_OFFER_HISTORY_LIST_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/destinationService/buyer/offerHistory/${offerId}`,
      method: 'DELETE'
    }
  };
};
export const getHouseHuntingList = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_HOUSE_HUNTING_LIST_REQUEST, GET_AUTH_HOUSE_HUNTING_LIST_SUCCESS, GET_AUTH_HOUSE_HUNTING_LIST_FAILURE],
      authenticated: true,
      endpoint: `api/HouseHunting/GetByClientId/${id}`,
      method: 'GET'
    }
  };
};

export const postHouseHuntingList = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_HOUSE_HUNTING_LIST_REQUEST, POST_AUTH_HOUSE_HUNTING_LIST_SUCCESS, POST_AUTH_HOUSE_HUNTING_LIST_FAILURE],
      authenticated: true,
      endpoint: 'api/HouseHunting/',
      method: 'POST',
      payload: values
    }
  };
};

export const updateHouseHuntingList = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_HOUSE_HUNTING_LIST_REQUEST, UPDATE_AUTH_HOUSE_HUNTING_LIST_SUCCESS, UPDATE_AUTH_HOUSE_HUNTING_LIST_FAILURE],
      authenticated: true,
      endpoint: 'api/HouseHunting/',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteHouseHuntingList = listItemId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_HOUSE_HUNTING_LIST_REQUEST, DELETE_AUTH_HOUSE_HUNTING_LIST_SUCCESS, DELETE_AUTH_HOUSE_HUNTING_LIST_FAILURE],
      authenticated: true,
      endpoint: `api/HouseHunting/${listItemId}`,
      method: 'DELETE'
    }
  };
};

export const getAuthDestinationServices = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_DESTINATION_SERVICES_REQUEST, GET_AUTH_DESTINATION_SERVICES_SUCCESS, GET_AUTH_DESTINATION_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/destinationService`,
      method: 'GET'
    }
  };
};

export const updateAuthDestinationServicesBuyer = (id, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_AUTH_DESTINATION_SERVICES_BUYER_REQUEST,
        UPDATE_AUTH_DESTINATION_SERVICES_BUYER_SUCCESS,
        UPDATE_AUTH_DESTINATION_SERVICES_BUYER_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${id}/destinationService/buyer`,
      method: 'PUT',
      payload: values
    }
  };
};

export const updateAuthDestinationServicesRenter = (id, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_AUTH_DESTINATION_SERVICES_RENTER_REQUEST,
        UPDATE_AUTH_DESTINATION_SERVICES_RENTER_SUCCESS,
        UPDATE_AUTH_DESTINATION_SERVICES_RENTER_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${id}/destinationService/renter`,
      method: 'PUT',
      payload: values
    }
  };
};

export const updateAuthDestinationTripsBuyer = (serviceId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_HOUSE_HUNTING_BUYER_REQUEST, UPDATE_AUTH_HOUSE_HUNTING_BUYER_SUCCESS, UPDATE_AUTH_HOUSE_HUNTING_BUYER_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/buyerTrip/${serviceId}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthDestinationTripsRenter = (serviceId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_HOUSE_HUNTING_RENTER_REQUEST, UPDATE_AUTH_HOUSE_HUNTING_RENTER_SUCCESS, UPDATE_AUTH_HOUSE_HUNTING_RENTER_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/renterTrip/${serviceId}`,
      method: 'POST',
      payload: values
    }
  };
};

export const deleteAuthDestinationTripsBuyer = (tripId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_HOUSE_HUNTING_BUYER_REQUEST, DELETE_AUTH_HOUSE_HUNTING_BUYER_SUCCESS, DELETE_AUTH_HOUSE_HUNTING_BUYER_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/buyerTrip/${tripId}`,
      method: 'DELETE',
      payload: values
    }
  };
};

export const deleteAuthDestinationTripsRenter = (tripId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_HOUSE_HUNTING_RENTER_REQUEST, DELETE_AUTH_HOUSE_HUNTING_RENTER_SUCCESS, DELETE_AUTH_HOUSE_HUNTING_RENTER_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/renterTrip/${tripId}`,
      method: 'DELETE',
      payload: values
    }
  };
};

export const updateMortgageLeads = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_MORTGAGE_LEADS_REQUEST, UPDATE_MORTGAGE_LEADS_SUCCESS, UPDATE_MORTGAGE_LEADS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/destinationService/leads`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getMortgageLeads = fileId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_MORTGAGE_LEADS_REQUEST, GET_MORTGAGE_LEADS_SUCCESS, GET_MORTGAGE_LEADS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/destinationService/leads`,
      method: 'GET'
    }
  };
};

export const sendMortgageLeads = fileId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [SEND_MORTGAGE_LEADS_REQUEST, SEND_MORTGAGE_LEADS_SUCCESS, SEND_MORTGAGE_LEADS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/destinationService/leads/send`,
      method: 'PUT'
    }
  };
};

export const getDestinationEstimatedDates = fileId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_DESTINATION_ESTIMATED_DATES_REQUEST, GET_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS, GET_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/destinationService/estimatedDates`,
      method: 'GET'
    }
  };
};

export const updateDestinationEstimatedDates = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_REQUEST,
        UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS,
        UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/destinationService/estimatedDates`,
      method: 'PUT',
      payload: values
    }
  };
}
